import { MAZE_START_TIMER } from '@/constants/maze';
import previewService from '@/services/api/preview';
import type { PreviewMazeLevelDto } from '@/types/api/preview';
import { MazeGamePhase } from '@/types/maze-phase';
import { create, type StateCreator } from 'zustand';

interface PreviewState {
  phase: MazeGamePhase;
  timer: number;
  level: number;
  isLoading: boolean;
  previewLevel: PreviewMazeLevelDto | null;
}

interface PreviewActions {
  loadPreview: (boardId: string, token: string) => Promise<void>;
  completeLevel: (remainingTime: number) => void;
  setTimer: (timer: number) => void;
  decrementTimer: () => void;
  reset: () => void;
}

export type PreviewStore = PreviewState & PreviewActions;

const initialState: PreviewState = {
  phase: MazeGamePhase.START,
  timer: MAZE_START_TIMER,
  level: 1,
  isLoading: false,
  previewLevel: null,
};

const previewStoreSlice: StateCreator<PreviewStore> = (set) => ({
  ...initialState,
  loadPreview: async (boardId, token) => {
    set({ ...initialState, isLoading: true });
    const previewLevel = await previewService.getPreviewMaze(boardId, token);
    set({
      isLoading: false,
      previewLevel,
      phase: MazeGamePhase.PLAYING,
      timer: MAZE_START_TIMER,
      level: 1,
    });
  },
  completeLevel: () =>
    set({
      phase: MazeGamePhase.WIN,
    }),
  setTimer: (timer) => set({ timer }),
  decrementTimer: () => set((state) => ({ timer: Math.max(0, state.timer - 1) })),
  reset: () => set(initialState),
});

export const usePreviewStore = create(previewStoreSlice);
